/* eslint-disable import/prefer-default-export */
import makeApiCall from './makeApiCall';

export const login = (data) => makeApiCall(`/user/authenticate`, 'POST', data);

export const loginOTP = (data) => makeApiCall(`/user/auth/login`, 'POST', data);

export const generateOTP = (data) => makeApiCall(`/user/auth/generate-otp`, 'POST', data);

export const verifyOTP = (data) => makeApiCall(`/user/auth/verify-otp`, 'POST', data);
